
export const themeColors = {
  primary: "#94302c",
  primaryLight: "#f0f9f5",
  secondary: "#c2a83e",
  success: "#00a676",
  info: "#3a8edb",
  warning: "#f4b942",
  danger: "#e63946",
  light: "#eaf4ee",
  dark: "#053c23"
};

 

export const getColor = (availableColor = 'primary') => {
  if (typeof window === 'undefined') {
    return null;
  }

  const color = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(`--${availableColor}`);

  return color;
};

export const getThemeColors = () => [
  'primary',
  'secondary',
  'success',
  'info',
  'warning',
  'danger',
];

export const custTableStyles = {
  headRow: {
    style: {
      borderRadius: '8px',
      minHeight: '40px', // override the row height
      //maxHeight: '40px',
      background: "#518ada",
    }
  },
  rows: {
    style: {
      minHeight: '40px', // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: '8px', // override the cell padding for head cells
      paddingRight: '8px',
      fontSize: '0.9rem',
      fontWeight: 'bold',
      minHeight: '40px',
      color: "#212529"
    },
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};
